<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>Media Management</h2>
          <button pButton class="p-button-success save-button" label="Save"
            [disabled]="getSaveButtonDisabled()"
          (click)="saveMediaManagementSettings()"></button>
        </div>
      </ng-template>
      <p-tabs value="google">
        <p-tablist>
          <p-tab value="google">
            <span>
              Google <i class="pi pi-fw pi-google"></i>
            </span>
          </p-tab>
          <p-tab value="meta">
            <span>
              Meta <i class="pi pi-fw pi-facebook"></i>
            </span>
          </p-tab>
          <p-tab value="microsoft">
            <span>
              Microsoft <i class="pi pi-fw pi-microsoft"></i>
            </span>
          </p-tab>
          <p-tab value="media-tags">
            <span>
              Media Tags <i class="pi pi-fw pi-tag"></i>
            </span>
          </p-tab>
          <p-tab value="general">
            <span>
              General <i class="pi pi-fw pi-cog"></i>
            </span>
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="google">
            @if (mediaManagementSettings) {
              <auto-google-settings
                [settings]="mediaManagementSettings"
                [account]="account"
                [showPaymentsInGva]="showPaymentsInGva"
                (dataEmitter)="onGoogleFormGroupInitialized($event)">
              </auto-google-settings>
            }
          </p-tabpanel>
          <p-tabpanel value="meta">
            @if (mediaManagementSettings) {
              <auto-facebook-settings
                [settings]="mediaManagementSettings"
                [account]="account"
                (dataEmitter)="onFacebookFormGroupInitialized($event)">
              </auto-facebook-settings>
            }
          </p-tabpanel>
          <p-tabpanel value="microsoft">
            @if (mediaManagementSettings) {
              <auto-microsoft-settings
                [settings]="mediaManagementSettings"
                [account]="account"
                (dataEmitter)="onMicrosoftFormGroupInitialized($event)">
              </auto-microsoft-settings>
            }
          </p-tabpanel>
          <p-tabpanel value="media-tags">
            <auto-media-tags-settings
              [accountId]="accountId"
            ></auto-media-tags-settings>
          </p-tabpanel>
          <p-tabpanel value="general">
            @if (mediaManagementSettings) {
              <auto-general-settings
                [settings]="mediaManagementSettings"
                (dataEmitter)="onGeneralFormGroupInitialized($event)">
              </auto-general-settings>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
